import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import ArrowRoundedIcon from 'assets/images/arrows/arrowRoundedIcon.svg?react';
import cn from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

interface InputRadioGroupProps {
	name: string;
	values: any;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	radioButtons: any;
	cyTestRef?: string;
	rowDirection?: boolean;
}
export const InputRadioGroup = ({ name, values, onChange, radioButtons, cyTestRef, rowDirection }: InputRadioGroupProps) => {
	const [expandList, setExpandList] = useState(false);
	const { t } = useTranslation();

	const handleExpandList = () => {
		setExpandList(!expandList);
	};
	return (
		<>
			<RadioGroup
				aria-label={name}
				name={name}
				value={values[name]}
				onChange={onChange}
				className={cn('radioGroup', { 'radioGroup--expanded': expandList })}
			>
				<div className={`radioGroup__list ${rowDirection && 'radioGroup__row_direction'}`}>
					{radioButtons.map((item: any, index: number) => (
						<FormControlLabel
							key={`radioGroup-${name}-${index}`}
							value={item.value}
							control={<Radio value={item.value} color="default" />}
							label={<div className="radioGroup__label">{item.label}</div>}
							labelPlacement="end"
							data-cy={cyTestRef}
						/>
					))}
				</div>
			</RadioGroup>
			{radioButtons.length > 5 && !expandList && (
				<div className="radioGroup__expand" onClick={handleExpandList}>
					{t('showMore')}
					<ArrowRoundedIcon className={cn('radioGroup__expand__icon', { 'radioGroup__expand__icon--clicked': expandList })} />
				</div>
			)}
		</>
	);
};

export default InputRadioGroup;
